import React from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import './style.less';
import PropTypes from 'prop-types';
import { routes } from '../../constants/routes';
import Market from '../../components/Market';
import Employees from '../../components/Employee';
import Property from '../../components/Property';
import PropertyTenantCountMapping from '../../components/Property/PropertyTenantCountMapping';
import Assignments from '../../components/Assignments';
import Allocations from '../../components/Allocations';
import Transition from '../../components/Transition';
import PTFDetail from '../../components/Transition/PTFDetail';
import Dashboard from '../../components/Dashboard/DashBoard';
import PendingRequest from '../../components/PendingRequest';
import Reports from '../../components/Reports/Reports';
import { pure } from 'recompose';
import Configurations from '../../components/configuration/configurations';
import ReimbursementVarianceAnalysis from '../../components/ReimbursementVarianceAnalysis/ReimbursementVarianceAnalysis';
import { IsSectionVisible, IsBillingAccountingTabVisible, IsComplianceAccess, IsYearEndBonusAccess } from '../../utils/helper';
import { SECTIONS } from '../../constants/appConstants';
import ErrorPage from '../ErrorPage';
import commonLabels from '../../constants/messageConstants';
import ShowAllPendingNotifications from '../../components/common/TopNav/ShowAllPendingNotifications';
import FileViewer from '../../components/common/FileViewer';
import AboutUs from '../aboutUs';
import Clients from '../../components/Clients/Client';
import EmployeeTerminations from '../../components/EmployeeTerminations';
import OverTimeAttendance from '../../components/OvertimeAttendance/OverTimeAttendance';
import EmployeeOvertimeAttendance from '../../components/EmployeeOvertimeAttendance';
import BillingAdjustments from '../../components/BillingAdjustments';
import ClosePayCycle from '../../components/ClosePayCycle/ClosePayCycle';
import AllocationCompliance from '../../components/Compliance';
import EmployeeEstimatedBonus from '../../components/YearEndBonus/EmployeeBonus';
import EmployeeBonusAccrual from '../../components/YearEndBonus/EmployeeAccrual';
import YearEndBonusCompliance from '../../components/YearEndBonus/YearEndBonusCompliance';
import CloseYearEndBonus from '../../components/YearEndBonus/CloseYearEndBonus';

WorkSpace.propTypes = {
  defaultPage: PropTypes.string.isRequired
};
const renderMergedProps = (component, ...rest) => {
  const finalProps = Object.assign({}, ...rest);
  return React.createElement(component, finalProps);
};

const PropsRoute = ({ component, ...rest }) => {
  // console.log(rest, window.location);
  return (
    <Route
      {...rest}
      render={(routeProps) => {
        return renderMergedProps(component, routeProps, rest);
      }}
    />
  );
};
PropsRoute.propTypes = {
  component: PropTypes.element
};

function WorkSpace({ defaultPage }) {
  return (
    <>
      <Switch>
        <Redirect exact from="/" to={`/${defaultPage}`} />
        <PropsRoute
          path={`/${routes.error}`}
          component={ErrorPage}
          details={commonLabels.serverError}

        />
        <PropsRoute
          path={`/${routes.unAuthorizedAccess}`}
          component={ErrorPage}
          details={commonLabels.unAuthorizedAccess}
        />
        <PropsRoute
          path={`/${routes.notfound}`}
          component={ErrorPage}
          details={commonLabels.pageNotFound}
        />
        {/* <PropsRoute
          path={`/${IsSectionVisible(SECTIONS.DASHBOARD)
            ? routes.dashboard
            : routes.unAuthorizedAccess
            }`}
          component={IsSectionVisible(SECTIONS.DASHBOARD) ? Dashboard : ErrorPage}
        /> */}
        <PropsRoute
          path={`/${IsSectionVisible(SECTIONS.PENDING_ACTION)
            ? routes.pendingRequests
            : routes.unAuthorizedAccess
            }`}
          component={IsSectionVisible(SECTIONS.PENDING_ACTION) ? PendingRequest : ErrorPage}
        />
        <PropsRoute
          path={`/${IsSectionVisible(SECTIONS.MARKETS)
            ? routes.market
            : routes.unAuthorizedAccess
            }`}
          component={IsSectionVisible(SECTIONS.MARKETS) ? Market : ErrorPage}
        />
        <PropsRoute
          path={`/${IsSectionVisible(SECTIONS.EMPLOYEES)
            ? routes.employee
            : routes.unAuthorizedAccess
            }`}
          component={IsSectionVisible(SECTIONS.EMPLOYEES) ? Employees : ErrorPage}
        />
        <PropsRoute
          path={`/${IsSectionVisible(SECTIONS.PROPERTIES)
            ? routes.property
            : routes.unAuthorizedAccess
            }`}
          component={IsSectionVisible(SECTIONS.PROPERTIES) ? Property : ErrorPage}
        />
        <PropsRoute
          path={`/${IsSectionVisible(SECTIONS.CENTERALIZED_AR_PROPERTY_TENANT_MAPPING)
            ? routes.propertyTenantCountMapping
            : routes.unAuthorizedAccess
            }`}
          component={IsSectionVisible(SECTIONS.CENTERALIZED_AR_PROPERTY_TENANT_MAPPING) ? PropertyTenantCountMapping : ErrorPage}
        />
        <PropsRoute
          path={`/${IsSectionVisible(SECTIONS.PROPERTY_TRANSITION)
            ? routes.transition
            : routes.unAuthorizedAccess
            }`}
          component={IsSectionVisible(SECTIONS.PROPERTY_TRANSITION) ? Transition : ErrorPage}
        />
        <PropsRoute
          path={`/${IsSectionVisible(SECTIONS.PROPERTY_TRANSITION)
            ? routes.ptfDetail
            : routes.unAuthorizedAccess
            }`}
          component={IsSectionVisible(SECTIONS.PROPERTY_TRANSITION) ? PTFDetail : ErrorPage}
        />
        <PropsRoute
          path={`/${IsSectionVisible(SECTIONS.ASSIGNMENTS)
            ? routes.assignments
            : routes.unAuthorizedAccess
            }`}
          component={IsSectionVisible(SECTIONS.ASSIGNMENTS) ? Assignments : ErrorPage}
        />
        <PropsRoute
          path={`/${IsSectionVisible(SECTIONS.ALLOCATIONS)
            ? routes.allocations
            : routes.unAuthorizedAccess
            }`}
          component={IsSectionVisible(SECTIONS.ALLOCATIONS) ? Allocations : ErrorPage}
        />
        <PropsRoute
          path={`/${(IsSectionVisible(SECTIONS.CONFIGURATION) || IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION))
            ? routes.configurations
            : routes.unAuthorizedAccess
            }`}
          component={(IsSectionVisible(SECTIONS.CONFIGURATION) || IsSectionVisible(SECTIONS.DATA_CENTER_CONFIGURATION)) ? Configurations : ErrorPage}
        />
        <PropsRoute
          path={`/${IsSectionVisible(SECTIONS.DASHBOARD, SECTIONS.PENDING_ACTION)
            ? routes.pendingRequests
            : routes.unAuthorizedAccess
            }`}
          component={IsSectionVisible(SECTIONS.DASHBOARD, SECTIONS.PENDING_ACTION) ? PendingRequest : ErrorPage}
        />
        <PropsRoute
          path={`/${IsSectionVisible(SECTIONS.DASHBOARD, SECTIONS.PENDING_ACTION)
            ? routes.employeeTerminations
            : routes.unAuthorizedAccess
            }`}
          component={IsSectionVisible(SECTIONS.DASHBOARD, SECTIONS.PENDING_ACTION) ? EmployeeTerminations : ErrorPage}
        />
        <PropsRoute
          path={`/${IsSectionVisible(SECTIONS.DASHBOARD, SECTIONS.PENDING_ACTION)
            ? routes.pendingNotifications
            : routes.unAuthorizedAccess
            }`}
          component={IsSectionVisible(SECTIONS.DASHBOARD, SECTIONS.PENDING_ACTION) ? ShowAllPendingNotifications : ErrorPage}
        />
        {/* <PropsRoute
          path={`/${IsSectionVisible(SECTIONS.REIMBURSEMENT_VARIANCE_ANALYSIS)
            ? routes.reimbursementVarianceAnalysis
            : routes.unAuthorizedAccess
            }`}
          component={IsSectionVisible(SECTIONS.REIMBURSEMENT_VARIANCE_ANALYSIS) ? ReimbursementVarianceAnalysis : ErrorPage}
        /> */}
        <PropsRoute
          path={`/${IsSectionVisible(SECTIONS.REPORTS)
            ? routes.reports
            : routes.unAuthorizedAccess
            }`}
          component={IsSectionVisible(SECTIONS.REPORTS) ? Reports : ErrorPage}
        />

        <PropsRoute
          path={`/${IsSectionVisible(SECTIONS.CLIENTS)
            ? routes.clients
            : routes.unAuthorizedAccess
            }`}
          component={IsSectionVisible(SECTIONS.CLIENTS) ? Clients : ErrorPage}
        />
        <PropsRoute
          path={`/${IsSectionVisible(SECTIONS.OVERTIMEATTANDENCESHEET)
            ? routes.overtimeAttendance
            : routes.unAuthorizedAccess
            }`}
          component={IsSectionVisible(SECTIONS.OVERTIMEATTANDENCESHEET) ? OverTimeAttendance : ErrorPage}
        />
        {/* <PropsRoute
          path={`/${IsSectionVisible(SECTIONS.CLIENTS)
            ? routes.overtimeAttendance
            : routes.unAuthorizedAccess
            }`}
          component={IsSectionVisible(SECTIONS.CLIENTS) ? OverTimeAttendance : ErrorPage}
        /> */}
        <PropsRoute
          path={`/${routes.fileViewer
            }`}
          component={FileViewer}
        />
        <PropsRoute
          path={`/${IsSectionVisible(SECTIONS.ABOUT_US)
            ? routes.aboutUs
            : routes.unAuthorizedAccess
            }`}
          component={IsSectionVisible(SECTIONS.ABOUT_US) ? AboutUs : ErrorPage}
        />
        <PropsRoute
          path={IsSectionVisible(SECTIONS.OVERTIMEATTANDENCESHEET) ? `/${routes.employeeOvertimeAttendanceSheet}` : routes.unAuthorizedAccess}
          component={IsSectionVisible(SECTIONS.OVERTIMEATTANDENCESHEET) ? EmployeeOvertimeAttendance : ErrorPage}
        />
        <PropsRoute
          path={`/${IsBillingAccountingTabVisible()
            ? routes.billingAccountingAdjustments
            : routes.unAuthorizedAccess
            }`}
          component={IsBillingAccountingTabVisible() ? BillingAdjustments : ErrorPage}
        />
        <PropsRoute
          path={`/${IsBillingAccountingTabVisible()
            ? routes.closePayPeriod
            : routes.unAuthorizedAccess
            }`}
          component={IsBillingAccountingTabVisible() ? ClosePayCycle : ErrorPage}
        />
        <PropsRoute
          path={`/${IsSectionVisible(SECTIONS.ALLOCATION_COMPLIANCE)
            ? routes.compliance
            : routes.unAuthorizedAccess
            }`}
          component={IsSectionVisible(SECTIONS.ALLOCATION_COMPLIANCE) ? AllocationCompliance : ErrorPage}
        />
        <PropsRoute
          path={`/${IsYearEndBonusAccess()
            ? routes.employeeYearlyBonus
            : routes.unAuthorizedAccess
            }`}
          component={IsYearEndBonusAccess() ? EmployeeEstimatedBonus : ErrorPage}
        />
        <PropsRoute
          path={`/${IsYearEndBonusAccess()
            ? routes.yearlyBonusAccrual
            : routes.unAuthorizedAccess
            }`}
          component={IsYearEndBonusAccess() ? EmployeeBonusAccrual : ErrorPage}
        />
        <PropsRoute
          path={`/${IsSectionVisible(SECTIONS.YEAR_END_COMPLIANCE)
            ? routes.yearEndBonusCompliance
            : routes.unAuthorizedAccess
            }`}
          component={IsSectionVisible(SECTIONS.YEAR_END_COMPLIANCE) ? YearEndBonusCompliance : ErrorPage}
        />
        <PropsRoute
          path={`/${IsBillingAccountingTabVisible()
            ? routes.closeYearEndBonus
            : routes.unAuthorizedAccess
            }`}
          component={IsBillingAccountingTabVisible() ? CloseYearEndBonus : ErrorPage}
        />
        <Route
          component={() => <ErrorPage details={commonLabels.pageNotFound} />}
        />
      </Switch>
      {/* <IdleSessionTimer /> */}
    </>
  );
}
export default pure(WorkSpace);
